const defaultData = {
  previous: ''
};

const data = {
  namespaced: true,
  state: {
    nav: defaultData.nav
  },

  mutations: {
    updatePrevious: (state, url) => {
      state.previous = url;
    }
  }
};

export default data;
